import { Environment } from './environment.type';

export const environment = {
  production: true,
} as unknown as Environment; // This environment is only required for the build. In production, the config is loaded from json config files.
